var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryStartLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7279 12.2922C16.0074 13.7521 15.0321 15.2076 14.0329 16.5138C13.0368 17.8159 12.0373 18.9431 11.2856 19.7456C11.1857 19.8523 11.0903 19.9531 11 20.0476C10.9097 19.9531 10.8143 19.8523 10.7144 19.7456C9.96267 18.9431 8.96319 17.8159 7.96709 16.5138C6.96787 15.2076 5.99259 13.7521 5.27207 12.2922C4.54411 10.8172 4.125 9.43512 4.125 8.25C4.125 4.45304 7.20304 1.375 11 1.375C14.797 1.375 17.875 4.45304 17.875 8.25C17.875 9.43512 17.4559 10.8172 16.7279 12.2922ZM11 22C11 22 19.25 14.1813 19.25 8.25C19.25 3.69365 15.5563 0 11 0C6.44365 0 2.75 3.69365 2.75 8.25C2.75 14.1813 11 22 11 22Z",
    fill: "#005182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C9.48122 11 8.25 9.76878 8.25 8.25C8.25 6.73122 9.48122 5.5 11 5.5C12.5188 5.5 13.75 6.73122 13.75 8.25C13.75 9.76878 12.5188 11 11 11ZM11 12.375C13.2782 12.375 15.125 10.5282 15.125 8.25C15.125 5.97183 13.2782 4.125 11 4.125C8.72183 4.125 6.875 5.97183 6.875 8.25C6.875 10.5282 8.72183 12.375 11 12.375Z",
    fill: "#005182"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryStartLoc);
export default __webpack_public_path__ + "static/media/summary-start-loc.b6a1e71442f3e15b584eb84165d009a3.svg";
export { ForwardRef as ReactComponent };